"use strict";
class Contact extends HttpRequest {
  constructor() {
    super();
    this.resendTimer = null;
    this.user = null;
    this.duration = 5 * 60 /* 5 minutes	 */;
  }

  #resetForm(form) {
    form.reset();
    form.querySelectorAll("input").forEach((input) => {
      input.classList.remove("is-valid");
      input.classList.remove("is-invalid");
    });

    form.querySelectorAll("textarea").forEach((textarea) => {
      textarea.classList.remove("is-valid");
      textarea.classList.remove("is-invalid");
    });

    form.querySelectorAll("select").forEach((select) => {
      select.classList.remove("is-valid");
      select.classList.remove("is-invalid");
      select.classList.remove("active");
    });
  }

  #saveMessage(form) {
    const formData = new FormData(form);
    formData.append("module", "Forms");
    formData.append("action", "SaveForm");
    return this.FormRequest(formData, "contactForm_");
  }

  #submitForm(form) {
    return new Promise((resolve) => {
      const phone = form.querySelector("#contactForm_phone");
      const name = form.querySelector("#contactForm_name");

      validatePhoneNumberInput(phone);
      validateStringInput(name, 3, 30);
      validateStringInput(form.querySelector("#contactForm_subject"), 3, 40);
      validateStringInput(form.querySelector("#contactForm_message"), 5, 160);
      validateStringInput(form.querySelector("#contactForm_subject"), 3, 40);
      validateEmailInput(form.querySelector("#contactForm_email"));

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!form.checkValidity()) {
          form.classList.add("was-validated");
          return resolve(false);
        }

        form.classList.remove("was-validated");
        ShowLoading(form.querySelector('button[type="submit"]'));
        try {
          const result = await this.#saveMessage(form);
          this.#resetForm(form);
          Toast(result);
          resolve(true);
        } catch (error) {
          Toast(error);
          resolve(false);
        } finally {
          HideLoading(form.querySelector('button[type="submit"]'));
        }
      });
    });
  }

  async #modalForm(modalElm) {
    const contactUsModal = new Modal(modalElm);
    const contactFormElm = modalElm.querySelector("#contactForm");
    const submit = await this.#submitForm(contactFormElm);
    if (submit) {
      contactUsModal.hide();
    }

    /* reset form modal */
    modalElm.addEventListener("hidden.mdb.modal", async (e) => {
      contactFormElm.reset();
      contactFormElm.classList.remove("was-validated");
      contactFormElm.querySelectorAll("input").forEach((input) => {
        input.classList.remove("is-invalid");
        input.classList.remove("is-valid");
      });
    });
  }
  #pageForm() {
    const contactFormElm = document.querySelector("#contactForm");
    this.#submitForm(contactFormElm);
  }

  init() {
    const ContactUsModalElm = document.querySelector("#ContactUsModal");
    if (ContactUsModalElm) {
      this.#modalForm(ContactUsModalElm);
      return;
    }
    this.#pageForm(ContactUsModalElm);
  }
}

addEventListener("DOMContentLoaded", () => {
});
const $contact = new Contact();
$contact.init();
